<template>
    <v-container fluid class="align-center column" style="height: auto">
        <div class="path align-center">
            <div class="row screen-width" style="height: 24px; gap: 24px">
                <HomeOutline :size="24"></HomeOutline>
                <ChevronRight :size="24"></ChevronRight>
                <p>고객지원</p>
                <ChevronRight :size="24"></ChevronRight>
                <p>질문작성</p>
                <!-- <ChevronRight :size="24"></ChevronRight> -->
                <!-- <p>{{ product_models[selectedProduct] }}</p> -->
            </div>
        </div>

        <div id="product-select" class="column screen-width">
            <p style="font-size: 32px; font-weight: bold">질문 작성</p>

            <div style="width: 100%; height: 2px; background: black"></div>
        </div>

        <div
            class="row align-space-between screen-width"
            style="margin: 20px"
        >
            <p style="font-size: 28px; font-weight: bold">제품 분류</p>
            <div
                class="product-list"
                style="display: flex; align-content: center"
            >
                <button
                    v-for="(category, index) in categoryList"
                    :key="category"
                    @click="clickCategory(index)"
                    :class="{ selected: index == selectedCategory }"
                    style="
                        border: 1px solid black;
                        border-radius: 20px;
                        padding: 8px 12px;
                        background: white;
                    "
                >
                    <p style="font-size: 16px">
                        {{ category }}
                    </p>
                </button>
            </div>
        </div>

        <div
            class="row align-space-between screen-width"
            style="margin: 40px 0px"
        >
            <p style="font-size: 28px; font-weight: bold">제목</p>
            <input
                type="text"
                v-model="title"
                style="
                    width: 80%;
                    height: 56px;
                    border: 1px solid #a2a2a2;
                    padding: 12px;
                "
            />
        </div>

        <div class="screen-width" style="height: auto; margin-bottom: 100px">
            <QuillEditor
                id="editor"
                v-model:content="content"
                contentType="html"
                theme="snow"
                :modules="modules"
                toolbar="full"
                @textChange="onEditorChange"
            />
        </div>
        <button
            style="
                width: 320px;
                height: 50px;
                background: #27afe2;
                border-radius: 20px;
                color: white;
                font-size: 32px;
                font-weight: bold;
                margin: 40px;
            "
            @click="submitQna"
        >
            등록
        </button>
    </v-container>
</template>

<script>
import { ref, onMounted, onUpdated } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
// import BlotFormatter from "quill-blot-formatter";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";
import Close from "vue-material-design-icons/Close.vue";
import HomeOutline from "vue-material-design-icons/HomeOutline.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";

export default {
    name: "add-question-answer-layout",
    props: ["id"],
    components: {
        QuillEditor,
        ImageUploader,
        HomeOutline,
        Close,ChevronRight
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const categoryList = [
            "GPS플로터",
            "레이더",
            "무선/통신장비",
            "항해 안전장비",
            "항해 조타장비",
            "해상용 안테나/헤딩센서",
            "선박용 인산철배터리",
            "선박용 전기관련 제품",
            "부품 및 액세서리",
        ];

        const modules = [
            {
                name: "imageUploader",
                module: ImageUploader,
                options: {
                    upload: (file) => {
                        return new Promise((resolve, reject) => {
                            store
                                .dispatch("uploadImage", file)
                                .then((res) => {
                                    resolve(res.data.url);
                                })
                                .catch((err) => {
                                    reject("Upload failed");
                                    console.error("Error:", err);
                                });
                        });
                    },
                },
            },
        ];

        const onEditorChange = () => {
        };

        const selectedCategory = ref(null);
        const title = ref("");
        const content = ref("");
        const user_id = ref(null);

        const clickCategory = async (index) => {
            if (selectedCategory.value == index) {
                selectedCategory.value = null;
            } else {
                selectedCategory.value = index;
            }
        };

        // const clickSubCategory = async (index) => {
        //     selectedSubCategory.value = index;
        //     await store.dispatch(
        //         "getCategoryProductList",
        //         subCategoryList.value[selectedSubCategory.value].id
        //     );
        // };

        const submitQna = async () => {

            content.value = content.value.replace(
                '<iframe class="ql-video"',
                '<iframe class="ql-video" style="width:960px; height:600px"'
            );

            const qna = {
                userId: user_id.value,
                main_category: selectedCategory.value,
                title: title.value,
                detail: content.value,
            };
            await store
                .dispatch("addQna", qna)
                .then(() => {
                    alert("질문이 등록 되었습니다");
                    router.back();
                })
                .catch((error) => {
                    alert(error);
                });
        };

        onUpdated(() => {});

        onMounted(async () => {
             try {
                const userProfile = await store.dispatch("getUserProfile");
                user_id.value = userProfile.id;
            } catch (err) {
                console.log(err);
            }
        });

        return {
            categoryList,
            content,
            onEditorChange,
            modules,
            title,
            submitQna,
            selectedCategory,
            clickCategory,
        };
    },
};
</script>

<style scoped>
/* 화면 너비가 601px에서 900px 사이인 경우 */
@media (min-height: 601px) and (max-height: 850px) {
    .sensor-title {
        font-size: 0.675rem;
        padding: 2px 15px;
    }

    .sensor-value {
        padding: 5px 15px;
        font-size: 1rem;
    }
}

#product-select {
    padding: 40px 0px;
    gap: 24px;
}

.product-list {
    width: 80%;
    height: auto;
    background: #f4f4f4;
    border-radius: 10px;
    border: 1px solid #d9d9d9;
    padding: 30px;
    gap: 16px;
    flex-wrap: wrap;
}

ul {
    list-style-type: none;
    list-style: none;
}

.selected {
    background: #00a7e7 !important;
    color: white;
    font-weight: bold;
}

span {
    height: 20px;
}
</style>
